const translateMixin = {
  data: function () {
    return {
      commandLabels: {
        enter: { en: 'press ENTER', fr: 'Appuyez sur ENTER', zh: '按 ENTER 键' },
        submit: { en: 'Submit', fr: 'Soumettre', zh: '提交' }
      }
    }
  },
  methods: {
    getCommandLocale(command, langCode) {
      // check that the requested command is in the list
      const commandKnown = {}.hasOwnProperty.call(this.commandLabels, command)
      if (!commandKnown) {
        console.log(`${command} not in translation list`)
        return ''
      }

      // if we have a translation in the requested language, return it
      if (this.commandLabels[command][langCode]) return this.commandLabels[command][langCode]
      // otherwise return the emglish version
      return this.commandLabels[command].en
    }
  },
}

export default translateMixin